/* Live personalisation preview: mirrors the name field and ink colour onto the mockup. */
(function () {
  // Lets the visitor drag the preview text anywhere inside its mockup image —
  // purely a preview aid (see the "indicative only" copy next to it); position
  // isn't submitted with the order.
  function makeDraggable(el) {
    var container = el.closest('.dyo-preview, .media');
    if (!container) return;
    var dragging = false;
    var pointerId = null;

    function place(clientX, clientY) {
      var rect = container.getBoundingClientRect();
      var xPct = ((clientX - rect.left) / rect.width) * 100;
      var yPct = ((clientY - rect.top) / rect.height) * 100;
      xPct = Math.min(92, Math.max(8, xPct));
      yPct = Math.min(92, Math.max(8, yPct));
      el.style.left = xPct + '%';
      el.style.top = yPct + '%';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
    }

    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      pointerId = e.pointerId;
      el.setPointerCapture(pointerId);
      el.setAttribute('data-dragging', 'true');
      place(e.clientX, e.clientY);
      e.preventDefault();
    });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      place(e.clientX, e.clientY);
    });
    function stop() {
      if (!dragging) return;
      dragging = false;
      el.removeAttribute('data-dragging');
      if (pointerId !== null) { try { el.releasePointerCapture(pointerId); } catch (err) {} }
    }
    el.addEventListener('pointerup', stop);
    el.addEventListener('pointercancel', stop);
  }

  function initArtworkUpload(file) {
    if (file.hasAttribute('data-dyo-file-initialized')) return;
    var upload = file.closest('[data-dyo-upload]');
    if (!upload) return;
    var label = upload.querySelector('[data-dyo-file-label]');
    var inputContainer = upload.querySelector('[data-dyo-file-inputs]');
    var previews = upload.querySelector('[data-dyo-file-previews]');
    var selectedFiles = [];
    file.setAttribute('data-dyo-file-initialized', 'true');

    function renderFiles() {
      inputContainer.replaceChildren();
      previews.replaceChildren();

      selectedFiles.forEach(function (item, index) {
        var transfer = new DataTransfer();
        transfer.items.add(item.file);
        var submittedInput = document.createElement('input');
        submittedInput.type = 'file';
        submittedInput.name = 'properties[Artwork ' + (index + 1) + ']';
        submittedInput.files = transfer.files;
        submittedInput.hidden = true;
        inputContainer.appendChild(submittedInput);

        var preview = document.createElement('div');
        preview.className = 'dyo-upload__preview';
        var image = document.createElement('img');
        image.src = item.url;
        image.alt = item.file.name;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'dyo-upload__remove';
        remove.textContent = 'X';
        remove.setAttribute('aria-label', 'Remove ' + item.file.name);
        remove.addEventListener('click', function () {
          URL.revokeObjectURL(item.url);
          selectedFiles = selectedFiles.filter(function (selected) { return selected.id !== item.id; });
          renderFiles();
        });
        preview.append(image, remove);
        previews.appendChild(preview);
      });

      previews.hidden = selectedFiles.length === 0;
      if (label) label.textContent = selectedFiles.length ?
        selectedFiles.length + (selectedFiles.length === 1 ? ' file selected' : ' files selected') :
        'No files chosen';
    }

    file.addEventListener('change', function () {
      Array.from(file.files || []).forEach(function (selectedFile) {
        var duplicate = selectedFiles.some(function (item) {
          return item.file.name === selectedFile.name &&
            item.file.size === selectedFile.size &&
            item.file.lastModified === selectedFile.lastModified;
        });
        if (!duplicate) {
          selectedFiles.push({
            id: Date.now().toString(36) + Math.random().toString(36).slice(2),
            file: selectedFile,
            url: URL.createObjectURL(selectedFile)
          });
        }
      });
      file.value = '';
      renderFiles();
    });
  }

  function init(root) {
    var out = root.querySelector('[data-dyo-preview-text]');
    var img = root.querySelector('[data-dyo-preview-img]');
    var input = root.querySelector('[data-dyo-text]');
    var fallback = out ? out.getAttribute('data-fallback') || 'YOUR NAME' : '';

    if (input && out) {
      var sync = function () { out.textContent = input.value.trim() || fallback; };
      input.addEventListener('input', sync);
      sync();
    }

    if (out) makeDraggable(out);

    root.addEventListener('click', function (e) {
      var ink = e.target.closest('[data-dyo-ink]');
      if (ink) {
        root.querySelectorAll('[data-dyo-ink]').forEach(function (n) { n.setAttribute('aria-pressed', 'false'); });
        ink.setAttribute('aria-pressed', 'true');
        if (out) out.style.color = ink.getAttribute('data-dyo-ink');
        var hidden = root.querySelector('[data-dyo-ink-value]');
        if (hidden) hidden.value = ink.getAttribute('data-ink-name') || ink.getAttribute('data-dyo-ink');
        return;
      }
      var prod = e.target.closest('[data-dyo-product]');
      if (prod) {
        root.querySelectorAll('[data-dyo-product]').forEach(function (n) { n.setAttribute('aria-pressed', 'false'); });
        prod.setAttribute('aria-pressed', 'true');
        if (img && prod.getAttribute('data-img')) {
          img.src = prod.getAttribute('data-img');
          img.alt = prod.getAttribute('data-alt') || '';
        }
        var price = root.querySelector('[data-dyo-price]');
        if (price && prod.getAttribute('data-price')) price.textContent = prod.getAttribute('data-price');
        var note = root.querySelector('[data-dyo-note]');
        if (note && prod.getAttribute('data-note')) note.textContent = prod.getAttribute('data-note');
        var link = root.querySelector('[data-dyo-link]');
        if (link && prod.getAttribute('data-url')) link.href = prod.getAttribute('data-url');
      }
    });

    root.querySelectorAll('[data-dyo-file]').forEach(initArtworkUpload);
  }
  document.querySelectorAll('[data-dyo-customizer]').forEach(init);

  /* Homepage hero: one product per panel, each with its own add-to-cart
     form. Thumbnails swap the visible panel; colour swatches swap the
     panel's variant id, price and add-to-cart state. */
  function shuffle(items) {
    var shuffled = items.slice();
    for (var i = shuffled.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var item = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = item;
    }
    return shuffled;
  }

  function rotateHeroProducts(root, thumbs, panels) {
    var ids = Array.from(thumbs).map(function (thumb) { return thumb.getAttribute('data-product-id'); });
    var displayCount = Math.min(6, ids.length);
    if (!displayCount) return;

    var storageKey = 'dyoHeroRotation:' + (root.getAttribute('data-dyo-rotation-key') || root.id);
    var poolKey = ids.slice().sort().join(',');
    var state = {};
    try { state = JSON.parse(localStorage.getItem(storageKey)) || {}; } catch (err) {}

    var previous = state.pool === poolKey && Array.isArray(state.previous) ? state.previous : [];
    var remaining = state.pool === poolKey && Array.isArray(state.remaining) ? state.remaining : shuffle(ids);
    remaining = remaining.filter(function (id, index) {
      return ids.indexOf(id) !== -1 && remaining.indexOf(id) === index;
    });

    var selected = [];
    var nextRemaining = [];
    remaining.forEach(function (id) {
      if (selected.length < displayCount && previous.indexOf(id) === -1) selected.push(id);
      else nextRemaining.push(id);
    });

    if (selected.length < displayCount) {
      var newCycle = shuffle(ids.filter(function (id) {
        return previous.indexOf(id) === -1 && selected.indexOf(id) === -1;
      }));
      while (selected.length < displayCount && newCycle.length) selected.push(newCycle.shift());
      nextRemaining = newCycle;
    }

    if (selected.length < displayCount) {
      shuffle(ids).forEach(function (id) {
        if (selected.length < displayCount && selected.indexOf(id) === -1) selected.push(id);
      });
    }

    var firstId = selected[0];
    thumbs.forEach(function (thumb) {
      var id = thumb.getAttribute('data-product-id');
      thumb.hidden = selected.indexOf(id) === -1;
      thumb.setAttribute('aria-pressed', id === firstId ? 'true' : 'false');
    });
    selected.forEach(function (id) {
      var thumb = root.querySelector('[data-dyo-hero-thumb][data-product-id="' + id + '"]');
      if (thumb) thumb.parentNode.appendChild(thumb);
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-product-id') !== firstId;
    });

    try {
      localStorage.setItem(storageKey, JSON.stringify({ pool: poolKey, previous: selected, remaining: nextRemaining }));
    } catch (err) {}
  }

  function initHero(root) {
    if (root.hasAttribute('data-dyo-hero-initialized')) return;
    root.setAttribute('data-dyo-hero-initialized', 'true');
    var thumbs = root.querySelectorAll('[data-dyo-hero-thumb]');
    var panels = root.querySelectorAll('[data-dyo-hero-panel]');
    rotateHeroProducts(root, thumbs, panels);
    root.querySelectorAll('[data-dyo-file]').forEach(initArtworkUpload);

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var targetId = thumb.getAttribute('data-target');
        thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.id !== targetId; });
      });
    });

    root.addEventListener('click', function (e) {
      var ink = e.target.closest('[data-dyo-ink]');
      if (ink) {
        var inkPanel = ink.closest('[data-dyo-hero-panel]');
        if (!inkPanel) return;
        inkPanel.querySelectorAll('[data-dyo-ink]').forEach(function (n) { n.setAttribute('aria-pressed', 'false'); });
        ink.setAttribute('aria-pressed', 'true');
        var inkHidden = inkPanel.querySelector('[data-dyo-ink-value]');
        if (inkHidden) inkHidden.value = ink.getAttribute('data-ink-name') || ink.getAttribute('data-dyo-ink');
        return;
      }
      var swatch = e.target.closest('[data-dyo-color]');
      if (swatch) {
        var panel = swatch.closest('[data-dyo-hero-panel]');
        if (!panel) return;
        panel.querySelectorAll('[data-dyo-color]').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        swatch.setAttribute('aria-pressed', 'true');

        var variantInput = panel.querySelector('[data-dyo-variant-id]');
        if (variantInput) variantInput.value = swatch.getAttribute('data-variant-id');

        var price = panel.querySelector('[data-dyo-price]');
        if (price && swatch.getAttribute('data-price')) price.textContent = swatch.getAttribute('data-price');

        var previewImg = panel.querySelector('[data-dyo-preview-img]');
        if (previewImg && swatch.getAttribute('data-image')) {
          previewImg.src = swatch.getAttribute('data-image');
          previewImg.alt = swatch.getAttribute('data-image-alt') || previewImg.alt;
        }

        var available = swatch.getAttribute('data-available') === 'true';
        var addBtn = panel.querySelector('[data-dyo-add-btn]');
        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add to cart' : 'Sold out';
        }
      }
    });

  }
  document.querySelectorAll('[data-dyo-hero]').forEach(initHero);

  function updatePdpVariant(form) {
    var variantSelect = form.querySelector('[data-pdp-variant-id]');
    if (!variantSelect) return;

    var selectedValues = Array.from(form.querySelectorAll('[data-pdp-option-group]')).map(function (group) {
      var select = group.querySelector('[data-pdp-option-select]');
      if (select) return select.value;
      var swatch = group.querySelector('[data-pdp-option-value][aria-pressed="true"]');
      return swatch && swatch.getAttribute('data-pdp-option-value');
    });
    var selectedVariant = Array.from(variantSelect.options).find(function (option) {
      return JSON.stringify(JSON.parse(option.getAttribute('data-options'))) === JSON.stringify(selectedValues);
    });
    var section = form.closest('section') || document;
    var addBtn = form.querySelector('[data-pdp-add-btn]');

    if (!selectedVariant) {
      variantSelect.value = '';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
      return;
    }

    selectedVariant.selected = true;
    var variantPrice = selectedVariant.getAttribute('data-price');
    var price = section.querySelector('[data-pdp-price]');
    if (price) price.textContent = variantPrice;

    var comparePriceValue = selectedVariant.getAttribute('data-compare-price');
    var comparePrice = section.querySelector('[data-pdp-compare-price]');
    if (comparePrice) {
      comparePrice.textContent = comparePriceValue;
      comparePrice.hidden = !comparePriceValue;
    }

    var available = selectedVariant.getAttribute('data-available') === 'true';
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? ('Add to cart — ' + variantPrice) : 'Sold out';
    }

    var variantImage = selectedVariant.getAttribute('data-image');
    var gallery = form.closest('[data-gallery]');
    var mainImage = gallery && gallery.querySelector('[data-gallery-main]');
    if (variantImage && mainImage) {
      mainImage.src = variantImage;
      mainImage.alt = selectedVariant.getAttribute('data-image-alt') || '';

      var mediaId = selectedVariant.getAttribute('data-media-id');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.setAttribute('aria-pressed', thumb.getAttribute('data-media-id') === mediaId ? 'true' : 'false');
      });
    }
  }

  /* Resolve all PDP option controls to one Shopify variant. */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-pdp-option-value]');
    if (!swatch) return;
    var group = swatch.closest('[data-pdp-option-group]');
    if (!group) return;

    group.querySelectorAll('[data-pdp-option-value]').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
    swatch.setAttribute('aria-pressed', 'true');

    var form = swatch.closest('form');
    if (form) updatePdpVariant(form);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-pdp-option-select]')) return;
    var form = e.target.closest('form');
    if (form) updatePdpVariant(form);
  });
})();
